const {
    colorGroup1,
    minimumQuantrySurchargeThreshold,
    currency,
    apiClientBaseURL,
    commitTime,
    pricingRules,
    shippingCostsByFactor,
} = require("../config-client")

/**
 * convert object to string
 * @param {any} obj object
 * @returns {string} string
 */
function obj2str(obj) {
    if (Array.isArray(obj)) {
        return JSON.stringify(
            obj.map(function (idx) {
                return obj2str(idx)
            })
        )
    } else if (typeof obj === "object" && obj !== null) {
        var elements = Object.keys(obj)
            .sort()
            .map(function (key) {
                var val = obj2str(obj[key])
                if (val) {
                    return key + ":" + val
                }
            })

        var elementsCleaned = []
        for (var i = 0; i < elements.length; i++) {
            if (elements[i]) elementsCleaned.push(elements[i])
        }

        return "{" + elementsCleaned.join("|") + "}"
    }

    if (obj) return obj
}

/**
 *
 * @param {Product} product
 * @param {string} optionIdent
 * @returns {OptionEntry}
 */
function getProductOption(product, optionIdent) {
    if (product && product.options) {
        for (let i = 0; i < product.options.length; i++) {
            if (product.options[i].option.replace(/^[^#]*#/, "") == optionIdent) {
                return product.options[i]
            }
        }
    }
    return
}

/**
 *
 * @param {Product} product
 * @param {RALColor} [color]
 * @param {string[]} [options]
 * @param {boolean} [isDealer]
 * @returns {number}
 */
function getProductPrice(product, color, options, isDealer = false) {
    let price = isDealer ? product.price_net_dealer : product.price_net_end_customer
    if (color) {
        let inGroup1 = false
        colorGroup1.forEach((c) => {
            if (color.RAL == c.RAL) {
                inGroup1 = true
            }
        })

        if (!inGroup1) {
            const o = getProductOption(product, "ral")
            let ralPrice = o && o.price_net
            if (ralPrice) {
                price += ralPrice
            }
        }
    }

    if (options) {
        options.forEach((oIdent) => {
            if (product.options) {
                product.options.forEach((o) => {
                    if (oIdent == o.option) {
                        price += o.price_net
                    }
                })
            }
        })
    }

    // rabatte laut liste
    let lowerPrice = 0
    let upperPrice = 0
    let lowerDiscount = 0
    let upperDiscount = 0
    let discount = 0

    if (product.apply_pricing_rules) {
        for (let i = 0; i < pricingRules.length; i++) {
            if (pricingRules[i].from <= price) {
                lowerPrice = pricingRules[i].from
                lowerDiscount = pricingRules[i].discount
            } else if (!upperPrice) {
                upperPrice = pricingRules[i].from
                upperDiscount = pricingRules[i].discount
            }
        }
        if (!upperDiscount) {
            // max discount
            discount = lowerDiscount
        } else {
            // calc discount between
            discount =
                lowerDiscount + ((price - lowerPrice) / (upperPrice - lowerPrice)) * (upperDiscount - lowerDiscount)
        }
    }

    let finalPrice = price - price * (discount / 100)
    return Math.round(finalPrice * 100) / 100
}

/**
 *
 * @param {number} price
 * @param {number} vatPercent
 * @param {number} quantity
 * @param {boolean|string} localeString
 * @param {boolean} displayCurrency
 * @returns {number|string}
 */
function formatPrice(price, vatPercent = 0, quantity = 1, localeString = true, displayCurrency = false) {
    if (typeof price != "number" || isNaN(price)) return localeString ? "" : 0

    if (vatPercent) price *= vatPercent / 100 + 1

    const newPrice = (Math.round(price * 100) / 100) * quantity

    let _p

    try {
        _p = localeString
            ? newPrice.toLocaleString(typeof localeString == "string" ? localeString : "de", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              })
            : newPrice
    } catch (e) {
        // ssr error
        _p = localeString ? newPrice.toFixed(2) : newPrice
    }
    if (displayCurrency) {
        // add currency
        if (currency.position == "left") {
            return currency.sign + " " + _p
        } else {
            return _p + " " + currency.sign
        }
    }
    return _p
}

/**
 *
 * @param {number} price
 * @param {number} vatPercent
 * @param {number} quantity
 * @returns {number}
 */
function formatPriceNumber(price, vatPercent = 0, quantity = 1) {
    // @ts-ignore
    return formatPrice(price, vatPercent, quantity, false)
}

/** @type {CartSum} */
const cartSumInit = {
    subtotalNet: 0,
    subtotalGross: 0,
    minQtyNet: 0,
    minQtyGross: 0,
    packagingNet: 0,
    packagingGross: 0,
    shippingNet: 0,
    shippingGross: 0,
    totalNet: 0,
    totalGross: 0,
    totalVAT: 0,
}

/**
 * @param {CartSum} sum
 */
function setTotalSum(sum) {
    // @ts-ignore
    sum.totalNet = formatPrice(sum.subtotalNet + sum.packagingNet + sum.shippingNet + sum.minQtyNet, 0, 1, false)
    // @ts-ignore
    sum.totalGross = formatPrice(
        sum.subtotalGross + sum.packagingGross + sum.shippingGross + sum.minQtyGross,
        0,
        1,
        false
    )
    // @ts-ignore
    sum.totalVAT = formatPrice(sum.totalGross - sum.totalNet, 0, 1, false)
}

/**
 *
 * @param {CartSum} sum
 * @param {number} shipping
 * @param {number} vat
 */
function setShippingInSum(sum, shipping, vat) {
    // @ts-ignore
    sum.shippingNet = formatPrice(shipping, 0, 1, false)
    // @ts-ignore
    sum.shippingGross = formatPrice(sum.shippingNet, vat, 1, false)
}

/**
 *
 * @param {CartSum} sum
 * @param {number} surcharge
 * @param {number} vat
 */
function setMinQtySurchargeInSum(sum, surcharge, vat) {
    // bei >= 30 EUR brutto kein Mindermengenzuschlag
    sum.minQtyNet = sum.subtotalGross < minimumQuantrySurchargeThreshold ? surcharge : 0
    // @ts-ignore
    sum.minQtyGross = formatPrice(sum.minQtyNet, vat, 1, false)
}

/**
 * sum of shipping_factor < 1 -> 12 EUR
 * sum of shipping_factor >= 1 -> 49 EUR
 *
 * @param {CartItem[]} cart
 * @returns {number}
 */
function getShippingCostsByFactor(cart) {
    let f = 0
    cart.forEach((cartItem) => {
        f += cartItem.product.shipping_factor * cartItem.quantity
    })
    let cost = 0
    for (let c = 0; c < shippingCostsByFactor.length; c++) {
        if (f >= shippingCostsByFactor[c].from) {
            cost = shippingCostsByFactor[c].cost
        }
    }
    return cost
}

/**
 *
 * @param {CartItem[]} cart
 * @param {number} vat
 * @param {boolean} [calcPackaging]
 * @param {number} [shipping]
 * @param {number} [minQtySurcharge]
 * @returns {CartSum}
 */
function getCartSum(cart, vat, calcPackaging = false, shipping = 0, minQtySurcharge = 0) {
    const sum = { ...cartSumInit }

    if (cart) {
        cart.forEach((cartItem) => {
            sum.subtotalNet += cartItem.price.unit * cartItem.quantity
            // @ts-ignore
            sum.subtotalGross += formatPrice(cartItem.price.unit, vat, cartItem.quantity, false)
        })
    }

    if (calcPackaging) {
        /*
         * packaging costs
         * < 50 EUR = 2,50 EUR
         * >= 50 EUR = 3 % vom Warenwert
         * >= 200 EUR = 2 % vom Warenwert
         * >= 1000 EUR = 1 % vom Warenwert
         */
        switch (true) {
            case sum.subtotalGross < 50:
                sum.packagingNet = 2.5
                break
            case sum.subtotalGross < 200:
                sum.packagingNet = sum.subtotalGross * 0.03
                break
            case sum.subtotalGross < 1000:
                sum.packagingNet = sum.subtotalGross * 0.02
                break
            default:
                sum.packagingNet = sum.subtotalGross * 0.01
        }
        // @ts-ignore
        sum.packagingGross = formatPrice(sum.packagingNet, vat, 1, false)
    }

    setShippingInSum(sum, shipping, vat)
    setMinQtySurchargeInSum(sum, minQtySurcharge, vat)
    setTotalSum(sum)

    return sum
}

/**
 * api request via client or server
 * server function ssrRequest is called via context.ssrRequest, binded in ssr hook
 *
 * @param {string} endpoint
 * @param {ApiOptions} options
 * @param {import("../../../frontend/src/sentry")} sentry
 * @param {typeof fetch} _fetch
 * @returns {Promise<ApiResult<any>>}
 */
function apiRequest(endpoint, options, sentry, _fetch) {
    // TODO cache only for GET

    // first check cache if on client
    const cacheKey = obj2str({ endpoint: endpoint, options: options })

    // @ts-ignore
    if (typeof window !== "undefined" && window.__SSR_CACHE__) {
        // @ts-ignore
        const cache = window.__SSR_CACHE__[cacheKey]
        console.log("SSR:", cacheKey, cache)
        if (cache) {
            return Promise.resolve(cache)
        }
    }

    let method = "GET"

    let query = "&count=1"
    if (options?.filter) query += "&filter=" + encodeURIComponent(JSON.stringify(options.filter))
    if (options?.sort) query += "&sort=" + options.sort + "&sort=_id"
    if (options?.limit) query += "&limit=" + options.limit
    if (options?.offset) query += "&offset=" + options.offset
    if (options?.projection) query += "&projection=" + options.projection
    if (options?.lookup) query += "&lookup=" + options.lookup

    if (options?.params) {
        Object.keys(options.params).forEach((p) => {
            query += "&" + p + "=" + encodeURIComponent(options.params[p])
        })
    }

    /** @type {{[key: string]: string}} */
    let headers = {
        "Content-Type": "application/json",
    }

    if (options?.headers) headers = { ...headers, ...options.headers }

    if (typeof window === "undefined") {
        // server

        // reference via context from get hook to tree shake in client
        // @ts-ignore
        const d = context.ssrRequest(cacheKey, endpoint, query, Object.assign({}, options, { method, headers }))
        return d
    } else {
        // client
        let url = apiClientBaseURL + endpoint + (query ? "?" + query : "")

        const span = sentry.currentTransaction()?.startChild({
            op: "fetch",
            description: method + " " + url,
            data: Object.assign({}, options, { url }),
        })
        const trace_id = span?.toTraceparent()
        if (trace_id) {
            headers["sentry-trace"] = trace_id
        }

        console.log("fetch", url)
        const response = _fetch(url, {
            method,
            mode: "cors",
            headers,
        }).then((response) => {
            // compare release from header
            const _commitTime = parseInt(response?.headers?.get("x-commit-time") || "0")
            if (!isNaN(_commitTime) && _commitTime > commitTime) {
                console.log("new release, reloading...", _commitTime, commitTime)
                // show blocking message
                const el = document.createElement("div")
                el.style.position = "fixed"
                el.style.top = "0"
                el.style.left = "0"
                el.style.width = "100%"
                el.style.height = "100%"
                el.style.background = "white"
                el.style.opacity = "0.7"
                el.style.color = "black"
                el.style.zIndex = "10000"
                el.style.display = "flex"
                el.style.alignItems = "center"
                el.style.justifyContent = "center"
                el.style.fontSize = "2em"
                el.innerHTML = "Neue Version des Shops verfügbar, lade neu..."
                document.body.appendChild(el)
                window.setTimeout(() => {
                    window.location.reload()
                }, 1000)
                throw new Error("reload")
            }

            return response?.json().then((json) => {
                if (response?.status < 200 || response?.status >= 400) {
                    return Promise.reject({ response, data: json })
                }
                return Promise.resolve({ data: json || null, count: response.headers?.get("x-results-count") || 0 })
            })
        })

        span?.end()

        return response
    }
}

module.exports = {
    obj2str,
    apiRequest,
    getProductOption,
    getProductPrice,
    formatPrice,
    formatPriceNumber,
    setTotalSum,
    cartSumInit,
    getShippingCostsByFactor,
    getCartSum,
    setShippingInSum,
    setMinQtySurchargeInSum,
}
